import { CurrencyResource } from '@/main';

export default {
    methods: {
        async getCurrencies() {
            try {
                const currencyInfo = await CurrencyResource.get() 
                this.currencies = currencyInfo.data.currencies
            } catch (e) {
                console.log(e)
        
                this.$notify({
                    group: 'notification',
                    type: 'warn',
                    title: 'We have a problem',
                    text: 'Can not get currencies'
                });
            }
        }
    },

    created() {
        this.getCurrencies()
    }
};